export const MOTIF_CODES = {
  "Fêlés": "Fêlés",
  "Sales": "Sales",
  "Sang": "Sang",
  "Cassés": "Cassés",
  "Calibre non conforme": "Calibre NC",
  "Sous-poids": "Sous-poids",
  "Autre": "Autre",
};

export function fmtDate(iso) {
  if (!iso) return "—";
  const [y, m, d] = iso.split("-");
  return `${d}/${m}/${y}`;
}

export function fmtKg(n) {
  if (n === null || n === undefined) return "—";
  return `${Number(n).toLocaleString("fr-FR", { minimumFractionDigits: 1, maximumFractionDigits: 1 })} kg`;
}

export function batimentColor(b) {
  return { P1: "bg-amber-500 text-slate-950", P2: "bg-blue-600 text-white", P3: "bg-purple-600 text-white" }[b] || "bg-slate-200";
}
